import { Component, ElementRef, ViewChild } from '@angular/core';
import { IonicPage, ViewController } from 'ionic-angular';

import { LoadingAlertProvider } from './../../providers/loading-alert/loading-alert';
import { NoteCreateParams } from './../../models/note';

@IonicPage()
@Component({
  selector: 'page-order-add-note',
  templateUrl: 'order-add-note.html',
})
export class OrderAddNotePage {
  @ViewChild('messageInput') messageInput: ElementRef;

  params: NoteCreateParams = {};

  constructor(
    private viewCtlr: ViewController,
    private loadingAlert: LoadingAlertProvider
  ) {}

  ionViewDidLoad() {
    console.log('ionViewDidLoad OrderAddNotePage');
    this.params.notated_object = 'User';
  }

  // Actions

  didTapDismiss() {
    this.viewCtlr.dismiss();
  }

  didTapSave() {
    this.viewCtlr.dismiss(this.params);
  }

  didTapMarkLocation() {
    this.loadingAlert.showLoaderWithText('Getting location...');
    this.getCurrentPosition().then(
      location => {
        this.loadingAlert.dismissLoader();
        this.params.lat = location.latitude;
        this.params.lng = location.longitude;
      },
      error => {
        this.loadingAlert.dismissLoader();
        this.loadingAlert.showToastAlert(
          typeof error === 'string' ? error : 'Error getting your location'
        );
      }
    );
  }

  private getCurrentPosition(): Promise<CurrentPosition> {
    if (
      typeof navigator === 'undefined' ||
      !navigator.geolocation ||
      !navigator.geolocation.getCurrentPosition
    ) {
      return Promise.reject('Geolocation is not supported by this browser.');
    }

    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        position =>
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          }),
        () => reject('Unable to determine your current location.'),
        {
          enableHighAccuracy: true,
          maximumAge: 0,
          timeout: 10000,
        }
      );
    });
  }

  // Helpers

  validates() {
    return this.params.message && this.params.message.length;
  }
}

interface CurrentPosition {
  latitude: number;
  longitude: number;
}



// WEBPACK FOOTER //
// ./src/pages/order-add-note/order-add-note.ts